<template>
	<div>
		<TitleSection>
			<template #h1>
				Innovation beginnt beim Code
			</template>
			<template #h2>
				Wir entwickeln Lösungen, die Standards neu definieren.
			</template>
		</TitleSection>
		<NuxtLayout name="slider">
			<VerticalSplitSection>
				<template #left>
					<h3>Software, neu gedacht.</h3>
					<div>
						<p>
							Seit 2016 entwickeln wir maßgeschneiderte Softwarelösungen, die neue Maßstäbe setzen. Unser Fokus liegt auf intelligenter Technologie, die Prozesse automatisiert, vereinfacht und optimiert. Wir hinterfragen bestehende Systeme und entwickeln neue, effizientere Lösungen.
						</p>
						<p>
							Mailuft hat in den letzten Jahren an einer Vielzahl innovativer Projekte gearbeitet - von Social Networks über Surveys bis hin zu hochkomplexen, KI-gestützten Distributionslösungen. Während der Pandemie haben wir intelligente Systeme für Corona-Tests entwickelt und mit unseren Crypto-ATM- und Ticketsystemen moderne Finanz- und Zugangstechnologien mitgestaltet.
						</p>
						<p>
							Unser Ziel ist es, Software neu zu denken - mit klugen Algorithmen, smarter Automatisierung und einer klaren Vision für die Zukunft.
						</p>
					</div>
				</template>
				<template #right>
					<img src="~/assets/media/i/about-us.webp" alt="Software, neu gedacht" width="500" height="601" />
				</template>
			</VerticalSplitSection>
			<HorizontalSplitSection>
				<template #top>
					<h3>Innovation am digitalen Puls Wiens.</h3>
					<div>
						<p>
							Mailuft ist in Wien zuhause - und das ganz bewusst. Unser Unternehmen sitzt im DC Tower, dem Zentrum des Technologie-Quartiers Vienna DC. Hier, wo sich die Infrastruktur der Zukunft mit dem digitalen Puls der Stadt vereint, entwickeln wir Softwarelösungen, die Branchen verändern. Wien ist nicht nur eine der lebenswertesten Städte der Welt, sondern auch ein pulsierender Standort für Innovation und Spitzentechnologie.
						</p>
						<p>
							Die Umgebung rund um das Tech Gate bietet eine einzigartige Atmosphäre: hochmoderne Business-Hubs, klare Strukturen und die unmittelbare Nähe zu den Vordenkern der digitalen Wirtschaft. Zwischen global agierenden Technologieunternehmen und visionären Start-ups lässt es sich nicht nur hervorragend leben, sondern auch Code schreiben, der technologisch an der Spitze steht. Die Mischung aus internationaler Dynamik und dem klaren Fokus auf zukunftsorientierte Technologien inspiriert uns täglich, Softwarelösungen zu entwickeln, die ebenso leistungsstark wie wegweisend sind.
						</p>
						<p>
							Unsere Lage im Vienna DC bringt uns nicht nur in ein Ökosystem für globale Technologie, sondern bietet auch praktische Vorteile. Beste digitale Infrastruktur, schnelle Anbindungen und ein kreatives, internationales Umfeld machen diesen Standort zum idealen Platz für unser Technologieunternehmen. Hier entstehen unsere Algorithmen von morgen, hier wird Software neu gedacht.
						</p>
					</div>
				</template>
				<template #bottom>
					<img src="~/assets/media/i/vienna.webp" alt="Innovation am digitalen Puls Wiens" width="1920" height="600" />
				</template>
			</HorizontalSplitSection>
			<VerticalSplitSection>
				<template #left>
					<h3>Unsere Philosophie.</h3>
					<div>
						<p>
							Bei Mailuft steht Nachhaltigkeit nicht nur im Mittelpunkt unserer Produkte, sondern ist tief in unserer DNA verankert. Wir übernehmen Verantwortung - für die Umwelt, für zukünftige Generationen und für alle Menschen entlang unserer Wertschöpfungskette.
						</p>
						<p>
							Unser Handeln ist geprägt von einem ganzheitlichen Denken: ressourcenschonend, transparent und zukunftsorientiert. Wir glauben daran, dass unternehmerischer Erfolg und ökologische wie soziale Verantwortung Hand in Hand gehen müssen.
						</p>
						<p>
							Deshalb setzt Mailuft auf faire Partnerschaften, innovative Lösungen und einen respektvollen Umgang mit unserer Umwelt - für eine lebenswerte Zukunft, die wir gemeinsam gestalten.
						</p>
						<p>
							Diese Haltung treibt uns jeden Tag an, bewusste Entscheidungen zu treffen und nachhaltige Impulse in unserer Branche zu setzen.
						</p>
					</div>
				</template>
				<template #right>
					<img src="~/assets/media/i/philosophy.webp" alt="Unsere Philosophie" width="500" height="664" />
				</template>
			</VerticalSplitSection>
			<SingleSection>
				<h3>Qualität statt KI: Warum wir „Vibecoding“ ablehnen.</h3>
				<div>
					<p>
						Bei der Entwicklung unserer Software setzen wir aus Überzeugung auf 100 % menschliche Expertise und lehnen den Einsatz von generativem KI-Code sowie sogenanntem „Vibecoding“ konsequent ab. Während der Trend, Software per Prompts blind zusammenzuschustern, vordergründig nach Geschwindigkeit aussieht, erzeugt er in der Praxis massive technische Schulden. Aktuelle Langzeitstudien (wie die von GitClear) belegen, dass KI-gestütztes Programmieren zu einem dramatischen Anstieg von Code-Duplikaten und einem drastischen Rückgang von Refactoring und modularer Wiederverwendbarkeit führt. Das Ergebnis ist eine unübersichtliche, schwer wartbare „Code Slop“-Codebase, bei der niemand mehr die genauen Abhängigkeiten oder die zugrundeliegende Logik versteht.
					</p>
					<p>
						Neben der mangelhaften Architektur stellt KI-Code vor allem ein unkalkulierbares Sicherheitsrisiko dar. Großangelegte Security-Analysen (u. a. der Veracode GenAI Code Security Report) zeigen, dass über 40 % des von KI generierten Codes bekannte, gravierende Sicherheitslücken enthalten - von OWASP-Top-10-Schwachstellen bis hin zu fehlerhaften Authentifizierungslogiken. Zudem neigen Sprachmodelle zu gefährlichen „Halluzinationen“, bei denen sie nicht existierende Software-Bibliotheken importieren. Dies öffnet Angreifern Tür und Tor für gezielte Lieferketten-Angriffe (Slopsquatting), bei denen Schadsoftware unter diesen erfundenen Namen platziert wird.
					</p>
					<p>
						Wir lehnen KI nicht per se ab - im Gegenteil: Wir beobachten diese Entwicklung sehr genau und sehen das wahre Potenzial dort, wo KI physikalisch, mathematisch oder medizinisch an echte, hochspezifische Messdaten gekoppelt ist und präzise Ergebnisse liefert. Doch während generative Allrounder das Netz mit synthetischen Inhalten überschwemmen und sich durch das Wiederholen eigener Daten zunehmend von der Realität entkoppeln, setzen wir in der Softwareentwicklung auf das, was auch in Zukunft unersetzlich bleibt: menschliche Innovationskraft, architektonische Weitsicht und kompromisslose Code-Qualität. So beteiligen wir uns aktiv an einer digitalen Zukunft, die auf echter Substanz statt auf stochastischem Rauschen baut.
					</p>
				</div>
			</SingleSection>
			<HorizontalSplitSection>
				<template #top>
					<img src="~/assets/media/i/mailuefterl.webp" alt="Wiener &bdquo;Mailüfterl&ldquo; - ein Stern am Computerhimmel" width="1920" height="600" />
				</template>
				<template #bottom>
					<h3>„Wiener Mailüfterl“ - ein Stern am Computerhimmel.</h3>
					<div>
						<p>
							Das „Wiener Mailüfterl“ ist ein bedeutendes Stück österreichischer Computergeschichte und gilt als der erste vollständig mit Transistoren bestückte Computer auf dem europäischen Festland. Er wurde von 1955 bis 1958 unter der Leitung von Computerpionier Heinz Zemanek und seinem Team an der Technischen Universität Wien entwickelt. Der Rechner enthielt etwa 3.000 Transistoren und 5.000 Dioden, arbeitete mit einer Taktfrequenz von 132 kHz und benötigte rund 100.000 Lötstellen.
						</p>
						<p>
							Seinen ungewöhnlichen Namen erhielt das „Mailüfterl“ als humorvolle Anspielung auf die damals in den USA gebauten Röhrenrechner, die klangvolle Namen wie „Whirlwind“ (Wirbelwind) trugen - Zemanek kommentierte, dass es zwar nicht deren Rechengeschwindigkeit erreichen werde, aber „für ein Wiener Mailüfterl werde es reichen“.
						</p>
						<p>
							Der Name Mailuft ist eine Hommage an diesen Pioniergeist aus Wien, der zeigte, dass man etablierten Systemen mit innovativen, leichtfüßigen Lösungen begegnen kann. Heute ist das historische Gerät im Technischen Museum Wien ausgestellt.<br>
							<a href="https://www.youtube.com/watch?v=lvaiEW-Sm4A" target="_blank">Mehr Informationen dazu auf YouTube</a>
						</p>
					</div>
				</template>
			</HorizontalSplitSection>
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Über uns',
	ogTitle: 'Über uns: Mailuft',
	twitterTitle: 'Über uns: Mailuft',
	ogDescription: 'Wer wir sind und wofür wir stehen: Erfahren Sie alles über unsere Vision, Unternehmenswerte und die Menschen, die Mailuft mit Leidenschaft vorantreiben.',
	description: 'Wer wir sind und wofür wir stehen: Erfahren Sie alles über unsere Vision, Unternehmenswerte und die Menschen, die Mailuft mit Leidenschaft vorantreiben.',
	twitterDescription: 'Wer wir sind und wofür wir stehen: Erfahren Sie alles über unsere Vision, Unternehmenswerte und die Menschen, die Mailuft mit Leidenschaft vorantreiben.',
})

definePageMeta({
	layout: 'slider',
})
</script>